


  window.swatch_instances = [];


class Swatch_Main {
  constructor(object) {

    /*
    Expected object input:
    {
      "Processed_Swatch_JSON": The JSON swatch data which is passed gets cross processed by the Collection JSON and the Collection Products,
      "output_type": 'Product Main' || 'Product Item Card',
    }


    Object options:

    object.Product_Image_Swatches = Turn the swatch buttons into product image buttons
    object.Swatches_In_Slider = Turn the swatch buttons into product image buttons


    */

    this.options = object;

    this.all_swatches = object.Processed_Swatch_JSON;
    this.output_type = object.output_type;

    this.Cheapest_Fabric_Link_Through = object.Product_Main.Cheapest_Fabric_Link_Through;

    // References to the swatches
    this.fabrics = [];

    // References to the nodes
    this.swatch_nodes = [];
    this.fabric_nodes_list = [];``

    this.swatch_debug = {
      "fabric_metaobject_handles": [],
    };

    this.fabric_img_query_selector = object.Product_Main.current_fabric_img_query_selector;

    // Group mode will select certain elements of the JSON by a common group name, and then use the fabric name to filter them again (Weighted blankets ... different types of blankets, and then within each type there are different fabrics)
    this.groupMode = object.groupMode;
    // Ignore fabrics (groupOnly) will still filter by the group property, but regardless of fabric they will show all members of a group (Clothing)
    this.ignore_fabrics = object.groupOnly;

    this.Elaborate_Fabric_Design = object.Product_Main.Elaborate_Fabric_Design;

    this.output_container_div = document.createElement('div');
    
    this.class_data = {};

    this.Product_Item_ViewMore = object.Product_Item.View_Limit;

    this.Hex_Colours = object.hex_colours;

    this.Elaborate_Fabric_Design = object.Product_Main.Elaborate_Fabric_Design;

    this.init();

    
      const instance_object = {
        "Node" : this.output_container_div,
        "Object": this
      }
      window.swatch_instances.push(instance_object);
    

  }

  init(){

    document.currentScript.setAttribute("data-script-processed", "");

    this.create_structured_swatch_and_fabric_data();


    if(this.output_type === 'Product Main') {
      this.output_product_main();
    }
    else if(this.output_type === 'Product Item Card') {
      this.output_product_item_card();
    }
    else {
      console.warn(`No output type specified ~ ${this.output_type}`);
    }

    // Output container
    document.currentScript.parentNode.insertBefore(this.output_container_div, document.currentScript.nextSibling);

    
    this.apply_styling();

    // TEMP - ADD VIDEO
    // this.fabrics.find(item => item.name == "cord").modal_video_url = "https://cdn.shopify.com/videos/c/o/v/9a759bf57434439c9e25ff0ad436a262.mp4";

  }


  create_structured_swatch_and_fabric_data(){

    //  -------- Create Fabrics From Swatches --------
    this.all_swatches.forEach((swatch) => {
      if(swatch.swatch_prod_fabric_U_handle) {
        const u__handle = swatch.swatch_prod_fabric_U_handle;
        // Missing fabric object
        if(!this.fabrics.find(fabric => fabric.fabric_u_handle == u__handle)) {
          const obj = {};
          obj.name = u__handle;
          obj.current = false;
          obj.cheapest_product = {
            "price": swatch.swatch_prod_price_current,
            "compare_at_price": swatch.swatch_prod_price_original,
            "url": swatch.swatch_prod_url
          };
          obj.admin_reference = "N/A";
          obj.fake_fabric = true;
          obj.fabric_handle = swatch.swatch_prod_fabric_U_handle;
          obj.fabric_u_handle = swatch.swatch_prod_fabric_U_handle;
          obj.fabric_thumbnail_image = null;
          obj.fabric_title = swatch.swatch_prod_fabric;
          this.fabrics.push(obj);
        }

        const fabric_object = this.fabrics.find(fabric => fabric.fabric_u_handle == u__handle);

        if(swatch.swatch_prod_current) {
          fabric_object.current = true;
        }

        // Update Cheapest Product
        if(parseFloat(fabric_object.cheapest_product.price) > parseFloat(swatch.swatch_prod_price_current)) {
          fabric_object.cheapest_product = {
            "price": swatch.swatch_prod_price_current,
            "compare_at_price": swatch.swatch_prod_price_original,
            "url": swatch.swatch_prod_url
          };
        }

      }
      else {
        console.log("No Swatch U_Handle found:", swatch);
      }
    });



    if(this.groupMode) {
      // Remove any swatches which are not in group
      const found_swatch = this.all_swatches.find(swatch => swatch.swatch_prod_current);
      if(found_swatch && found_swatch.swatch_group) {
        const swatch_group_filter = found_swatch.swatch_group;        
        this.all_swatches = this.all_swatches.filter(obj => obj.swatch_group === swatch_group_filter);
      }
    }



    // Merge found fabrics_metadata items properties into the relevant 'this.fabric' item
    this.fabrics = this.fabrics.map(item => {
      const fabric_metaobject = fabrics_metadata.find(
        fabric => fabric.universal_handle === item.fabric_u_handle
      );
      // if found, merge metaobject data into the item
      if (fabric_metaobject) {
        return { ...item, ...fabric_metaobject };
      }
      return item;
    });



    if(!this.ignore_fabrics) {
      this.fabrics.forEach(fabric => {
        if(!fabric.hasOwnProperty("admin_reference")) {
          console.warn(`The following fabric can not be found in the following metaobject:`, 'On page value:',  fabric, 'Metaobject values', this.swatch_debug.fabric_metaobject_handles);
        }
      });
    }


    if(this.fabric_img_query_selector) {
      const imgEl = document.querySelector(this.fabric_img_query_selector);
      if (imgEl && imgEl.hasAttribute("src")) {
        const src = imgEl.getAttribute("src");
        this.fabrics.forEach(fabric => {
          if (fabric.current === true) {
            fabric.fabric_thumbnail_img_override = src;
          }
        });
      }
    }


  }


  output_product_main(){

    this.output_container_div.classList.add('swatch_and_fabric_area');

    if(!this.ignore_fabrics) {
      this.product_main__output_fabrics(
        {
          "outerClassList": ["swatch_main_container"],
          "elaborate_fabrics": {
            "allow": this.Elaborate_Fabric_Design,
            "display_all": true
          }
        }
      );

      // this.product_main__output_fabrics(
      //   {
      //     "outerClassList": ["mobile_fabrics"],
      //     "elaborate_fabrics": {
      //       "allow": this.Elaborate_Fabric_Design,
      //     }
      //   }
      // );


    }
    else {
      if(document.querySelector(".choose_a_fabric_label")) {
        document.querySelector(".choose_a_fabric_label").style.display = "none";
      }
    }

    this.product_main__output_swatches();

    if(!this.ignore_fabrics) {
      this.utility__show_swatches_by_specific_fabrics(this.fabrics.find(obj => obj.current === true)?.fabric_u_handle);
    }

    // Launches 'Premium Colour Swatches' section further down. Can be found in snippet 'c__OUTPUT_premium_colours'
    document.addEventListener("Premium_Swatches_Slider_Loaded", () => {
      if(typeof(run_premium_swatches) === 'function') {
        console.log(this);
        run_premium_swatches(this);
      }
    });

  }


  output_product_item_card(){

    this.product_item__output_swatches();

    this.extension__item_card_update();

  }


  product_main__output_swatches(){
    const swatch_container = document.createElement("div");
    swatch_container.classList.add("swatch_area_colours");
    swatch_container.classList.add("greySwatchBlock");
    swatch_container.classList.add("swatch_pad_L");

    const swatch_container_a_tag_container = document.createElement("div");
    swatch_container_a_tag_container.classList.add("swatch_area_colours__main_container");

    const swatch_container_a_tag_container_inner = document.createElement("div");
    swatch_container_a_tag_container_inner.classList.add("swatch_area_colours__main");


    const swatch_container_label = document.createElement("div");
    swatch_container_label.classList.add("option-name");
    swatch_container_label.innerText = `Valitse väri`;

    const swatch_badges_used = [];
    const swatch_badge_map = {
      "1": ``,
      "2": ``
    }
    
    this.all_swatches.forEach((swatch, index) => {
  
      const a = document.createElement("a");
  
      a.href = swatch.swatch_prod_url;
      a.setAttribute('data-fabric', swatch.swatch_prod_fabric); // ???
      a.setAttribute('data-u-handle', swatch.swatch_prod_fabric_U_handle);
      a.setAttribute('data-current-price', swatch.swatch_prod_price_current);
      a.setAttribute('data-tier', swatch.swatch_tier);
      a.classList = 'product-colour-swatch swatch_ProductMain swatch-product-image';
      if(swatch.swatch_prod_current){
        a.classList.add("current");
      }
 
      var swatch_img = swatch.swatch_img_asset;
      if(!swatch_img) {
        swatch_img = swatch.swatch_prod_img;
      }
      

      if(this.options.Product_Image_Swatches) {
        a.innerHTML = `<div class="swatch_img_area"><img src="${swatch.swatch_prod_img}" alt="${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}" loading="lazy" width="41" height="41"></div>`;
      }
      else if(this.Hex_Colours && swatch.swatch_prod_hex){
        a.innerHTML = `<div class="tooltip"><img src="${swatch.swatch_prod_img}" alt="${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}" loading="lazy" /><span>${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}</span></div><span class="hex_item" style="background-color: ${swatch.swatch_prod_hex}"><span class="hex_item_border_area" style="border-color: ${swatch.swatch_prod_hex}"></span></span>`;
        a.classList.add("hex_swatch_item");
      }
      else {
        a.innerHTML = `<div class="tooltip"><img src="${swatch.swatch_prod_img}" alt="${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}" loading="lazy" /><span>${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}</span></div><img src="${swatch_img}" alt="${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}" loading="lazy" width="41" height="41">`;
      }



      if(swatch.swatch_badge) {
        if(!swatch_badges_used.includes(`${swatch.swatch_badge} - ${swatch.swatch_prod_fabric}`)) {
          swatch_badges_used.push(`${swatch.swatch_badge} - ${swatch.swatch_prod_fabric}`);
          if(swatch_badge_map[swatch.swatch_badge]) {
            const txt = swatch_badge_map[swatch.swatch_badge];
            a.innerHTML = `<span class="swatch_badge_txt">${txt}</span>` + a.innerHTML;
          }
        }
      }


      if(this.ignore_fabrics) {
        a.classList.add('filterbyGroupOnly'); 
      }
      else {
        if(this.groupMode){
          a.classList.add('filterbyGroup'); 
        }
        else {
          a.classList.add('filterbyFabric'); 
        }
      }

  
      // Hide other swatches
      swatch_container_a_tag_container_inner.appendChild(a);
      this.swatch_nodes.push(a);
  
    });

    swatch_container.appendChild(swatch_container_label);
    swatch_container_a_tag_container.appendChild(swatch_container_a_tag_container_inner);
    swatch_container.appendChild(swatch_container_a_tag_container);


    // Sort swatches into groups so that we can display 'Premium' colours etc
    this.extension__sort_swatches_into_tiers(swatch_container_a_tag_container);

    if(this.options.Swatches_In_Slider) {
      const swatch_parents = [];
      this.swatch_nodes.forEach(swatch => { if(!swatch_parents.includes(swatch.parentElement)) swatch_parents.push(swatch.parentElement) });
      swatch_parents.forEach(swatch_parent => {
        const array_ = Array.from(swatch_parent.querySelectorAll(".product-colour-swatch"));
        if(array_.length > 0) {
          this.utility__swiperfy_items(array_, {
          "container_outer": null,
          "container_inner": null
          });
        }
      });
    }

    this.swatch_nodes.forEach(swatch_node => {
      swatch_node.addEventListener("click", ()=> {
        if(document.body.classList.contains("async_renderer")) {
          this.swatch_nodes.forEach(generic_swatch_node => generic_swatch_node.classList.remove("current"));
          swatch_node.classList.add("current");
        }
      });
    });

    this.output_container_div.appendChild(swatch_container);


    /*
    if(this.class_data.fabric_comparison?.length == 2){
      this.extension__fabric_comparison_modal(".product_swatch_area .choose_a_fabric_label");
    }
    */

  }


  product_main__output_fabrics(options){

    const fabric_container = document.createElement('div');
    fabric_container.classList.add('swatch_area_fabrics');

    if(options.outerClassList) {
      options.outerClassList.forEach(class_item => {
        fabric_container.classList.add(class_item);
      });
    }

    if(this.fabrics.length > 1) {

      this.fabrics.forEach(fabric => {
        const fabric_span = document.createElement('span');
        fabric_span.classList = `fabric_parent fabric_parent_${fabric.fabric_handle}`;
        fabric_span.setAttribute('data-fabric-container', fabric.fabric_title); // ???
        fabric_span.setAttribute('data-fabric-u-handle', fabric.fabric_u_handle);
        if(fabric.current) {
          fabric_span.classList.add('selected');
        }
        fabric_span.setAttribute('data-current', fabric.current);
        fabric_span.innerHTML = `<span>${fabric.fabric_title ? fabric.fabric_title : "Muut kankaat"}</span>`;
        fabric_container.appendChild(fabric_span);
        fabric_span.addEventListener("click", function(e){
          this.utility__fabric_button_click(e.currentTarget);
        }.bind(this));
        this.fabric_nodes_list.push(fabric_span);
      });
  
    }

    if(options?.elaborate_fabrics?.allow){
      try {
          this.extension__elaborate_fabric_design(options.elaborate_fabrics, fabric_container);
      }
      catch(e) {
        console.warn(`Error in elaborating fabric design`, e);
      }
    }


    if(this.fabric_nodes_list.length > 1 && (this.fabrics.length > 1)) {
      this.output_container_div.appendChild(fabric_container);
      // Fabric Info
      if(options?.elaborate_fabrics?.allow){
        this.extension__fabric_information(fabric_container);
        Array.from(fabric_container.querySelectorAll(".fabric_parent")).forEach(node => node.addEventListener("click", () => {
          this.extension__fabric_information(fabric_container);
        }));
      }
    }
    else {
      if(this.output_container_div.querySelector(".choose_a_fabric_label")) {
        this.output_container_div.querySelector(".choose_a_fabric_label").style.display = "none";
      }
      else if(document.querySelector(".choose_a_fabric_label")) {
        document.querySelector(".choose_a_fabric_label").style.display = "none";
        document.querySelector(".choose_a_fabric_label").setAttribute("data-info", "Hidden via Swatch.js");
      }
    }

  }


  product_item__output_swatches(){

    if(this.all_swatches.find(swatch => swatch.swatch_prod_current == true)) {

      this.output_container_div.classList.add('product-card-swatches');

      const swatch_output_nodes = [];

      var fabric = false;

      if(this.fabrics.length > 0) {
        fabric = (this.fabrics.find(i => i.current == true))?.fabric_title;
      }


      this.all_swatches.forEach(swatch => {

        var allow = true;

        // Confirm its the correct fabric
        if(!this.ignore_fabrics) {
          if(fabric && fabric != swatch.swatch_prod_fabric){
            allow = false;
          }
        }
        
        if(allow) {
          const a = document.createElement("a");
          a.href = swatch.swatch_prod_url;
          a.setAttribute('data-fabric', swatch.swatch_prod_fabric);
          a.setAttribute('data-u-handle', swatch.swatch_prod_fabric_U_handle);
          a.setAttribute('data-current-price', swatch.swatch_prod_price_current);
          a.classList = 'product-colour-swatch swatch_ProductMain';


          
          if(swatch.swatch_prod_title) /*new_title*/     { a.setAttribute("data_product_title", swatch.swatch_prod_title); }
          if(swatch.swatch_prod_subtitle) /*new_subtitle*/     { a.setAttribute("data_product_subtitle", swatch.swatch_prod_subtitle); }
          if(swatch.swatch_prod_img) /*new_img*/     { a.setAttribute("data_product_img", swatch.swatch_prod_img); }
          if(swatch.swatch_prod_img_srcset) /*new_img_srcset*/     { a.setAttribute("data_product_img_srcset", swatch.swatch_prod_img_srcset); }
    
          if(swatch.swatch_prod_img_secondary) /*new_secondary_img*/     { a.setAttribute("data_product_img_secondary", swatch.swatch_prod_img_secondary); }
          if(swatch.swatch_prod_img_srcset) /*new_secondary_img_srcset*/     { a.setAttribute("data_product_img_srcset_secondary", swatch.swatch_prod_img_srcset); }
    
          if(swatch.swatch_prod_price_current) /*new_price*/     { a.setAttribute("data_product_price_current", format_money_js(swatch.swatch_prod_price_current, "integer") ); }
          if(swatch.swatch_prod_price_original) /*new_price_original*/     { a.setAttribute("data_product_price_original", format_money_js(swatch.swatch_prod_price_original, "integer") ); }
          if(swatch.swatch_prod_url) /*new_url*/     { a.setAttribute("data_product_url", swatch.swatch_prod_url); }
          if(swatch.swatch_prod_vendor) /*new_vendor*/     { a.setAttribute("data_product_vendor", swatch.swatch_prod_vendor); }


          if(swatch.swatch_prod_current){
            a.classList.add("active");
          }

          var swatch_img = swatch.swatch_img_asset;
          if(!swatch_img) {
            swatch_img = swatch.swatch_prod_img;
          }


          if(this.Hex_Colours && swatch.swatch_prod_hex){
            a.innerHTML = `<span class="hex_item" style="background-color: ${swatch.swatch_prod_hex}"><span class="hex_item_border_area" style="border-color: ${swatch.swatch_prod_hex}"></span></span>`;
            a.classList.add("hex_swatch_item");
            a.classList.add("swatch_ProductItem");
            this.groupMode ? (this.ignore_fabrics ? a.classList.add('filterbyGroup') : a.classList.add('filterbyGroupOnly')) : a.classList.add('filterbyFabric');
            swatch_output_nodes.push(a);
          }
          else {
            a.innerHTML = `<img src="${swatch_img}" alt="${swatch.swatch_prod_subtitle ? swatch.swatch_prod_subtitle : swatch.swatch_prod_title}" loading="lazy">`;
            this.groupMode ? (this.ignore_fabrics ? a.classList.add('filterbyGroup') : a.classList.add('filterbyGroupOnly')) : a.classList.add('filterbyFabric');
            swatch_output_nodes.push(a);
          }

        }

      });


      if(swatch_output_nodes.length > 1) {
        swatch_output_nodes.forEach(a => {
          this.output_container_div.appendChild(a);
        });
      }



      const items_swatches = Array.from(this.output_container_div.querySelectorAll("a"));

      // View More Functionality
      if(this.Product_Item_ViewMore) {

        if(items_swatches.length > (this.Product_Item_ViewMore + 1)) {
          
          // Hide items that are over view more limit
          items_swatches.forEach((item, index) => {
            if((index + 1) > this.Product_Item_ViewMore) {
              item.style.display = "none";
            }
          });
          
          const view_more_btn = document.createElement("button")
          view_more_btn.setAttribute("title", "Näytä kankaat");
          view_more_btn.setAttribute("aria-label", "Näytä kankaat");
          view_more_btn.setAttribute("data-has-loc-attr", "Näytä lisää");
          view_more_btn.classList.add("view_more");
          view_more_btn.addEventListener("click", function(e){
            const a_targets = Array.from(this.closest(".product-card-swatches").querySelectorAll("a.product-colour-swatch"));
            a_targets.forEach(a => a.style.display = "");
            this.style.display = "none";
          });
          this.output_container_div.insertBefore(view_more_btn, items_swatches[this.Product_Item_ViewMore]);
          this.output_container_div.classList.add('has_view_more');

        }
      }

    }

  }




  extension__elaborate_fabric_design(settings, container_node) {

    const current = this.fabrics.find(fabric => fabric.current === true);

    // Initial, add view-more button to all. We will later filter this and make action on the assign state
    Array.from(container_node.children).forEach(child => {
      if((child.classList.contains("fabric_parent")) && (!child.classList.contains("selected"))){
        child.classList.add("view_more_fabric")
      }
      else if(child.classList.contains("selected")) {
        container_node.insertBefore(child, container_node.querySelector(".fabric_parent"));
      }
    });

    if(current?.options?.put?.better_best) {
      this.utility__ext_elabFabric___find_PUT_premium_partners(container_node, current);      
    }
    else {
      this.utility__ext_elabFabric___find_premium_partner(container_node);
      this.utility__ext_elabFabric___find_best_fabric(container_node);      
    }


    const convert_to_elaborate_fabric = (item, options) => {

      if(!item.classList.contains("elaborate_fabric")) {

        const fabric_u_handle = item.getAttribute("data-fabric-u-handle");

        const found_JSON_item = this.fabrics.find(fabric => fabric.fabric_u_handle === fabric_u_handle);

        if(options.hide){
          item.style.display = "none";
        }

        var elab_fabric_img = false;
        if(found_JSON_item.fabric_thumbnail_image) { elab_fabric_img = found_JSON_item.fabric_thumbnail_image; }
        if(found_JSON_item.fabric_thumbnail_img_override) { elab_fabric_img = found_JSON_item.fabric_thumbnail_img_override; }
        if(!elab_fabric_img) {
          if(this.all_swatches.find(swatch => swatch.swatch_prod_fabric === found_JSON_item.fabric_title)){
            if((this.all_swatches.find(swatch => swatch.swatch_prod_fabric === found_JSON_item.fabric_title).swatch_prod_img)){
              elab_fabric_img = (this.all_swatches.find(swatch => swatch.swatch_prod_fabric === found_JSON_item.fabric_title).swatch_prod_img);
            }
          }
        }


        let from_price_html = "";
        if(found_JSON_item.cheapest_product.price && (!found_JSON_item.options?.hide_from_price_from_tab == true)) {
          let actual_price = format_money_js((found_JSON_item.cheapest_product.price), "integer");

          
            from_price_html = `<span class="from_price">Alkaen ${actual_price}</span>`;
          

        }

        // Temp image to pass query
        elab_fabric_img = true;
        if(elab_fabric_img && found_JSON_item.fabric_title) {
          item.innerHTML = `<div class="top_info">
            
            <h4 class="elaborate_fabric_title">${found_JSON_item.fabric_title}</h4>${from_price_html}
          </div>`;
          item.classList.add("elaborate_fabric");
        }
        else {
          console.warn("Missing fabric data", item, e);
        }
      }
    }
    // Assigns which fabrics will be a view more, and which will not
    this.utility__ext_elabFabric___assign_fabric_states(container_node);
    
    // Convert all items to elaborate fabrics
    if(settings.display_all) {
      let insert_view_more_fabrics = false;
      for(var i = 0; i < container_node.children.length; i++){

        if(!container_node.children[i].classList.contains("elaborate_fabric")) {

          // Hide items based on if they are going into the 'view more' area or not 
          let hide_val = false;
          if(container_node.children[i].classList.contains("view_more_fabric")){
            hide_val = true;
          }

          convert_to_elaborate_fabric(container_node.children[i], {"hide": hide_val});
        }


        if(i == 1 && container_node.children.length > 2) {
          insert_view_more_fabrics = document.createElement("div");
          insert_view_more_fabrics.id = "fabric_view_more_panel";
          insert_view_more_fabrics.classList = "fabric_parent elaborate_fabric";
          insert_view_more_fabrics.innerHTML = `
          <button id="fabric_reveal_btn" class="full_width" aria-controls="fabric_reveal" data-reinstantiate-swiper data-reinstantiate-swiper-delay="150">
            <span class="fabric_reveal_btn"><span></span></span>
          </button>
          `;


          insert_view_more_fabrics.querySelector("#fabric_reveal_btn").addEventListener("click", (e) => {
            insert_view_more_fabrics.remove();
            const list_of_hidden_fabrics = [];

            Array.from(container_node.querySelectorAll(".elaborate_fabric")).forEach(node => {
              if(node.style.display == "none") {
                list_of_hidden_fabrics.push(node);
              }
            });

            for(var i = 0; i < list_of_hidden_fabrics.length; i++) {
              console.log(`i = ${i}`);
              const target_item = list_of_hidden_fabrics[i];
              target_item.style.transition = "none";
              target_item.style.transform = "translateY(100px)";
              target_item.style.opacity = "0";
              target_item.style.display = "";
              target_item.style.transition = "0.6s";
              console.log(target_item);
              setTimeout(()=> {
                target_item.style.transform = "";
                target_item.style.opacity = "";
              }, (50 + (30 * i)));
            }

          });

        }
      }
      if(insert_view_more_fabrics && container_node.querySelector(".view_more_fabric")){
        const first_view_more_node = container_node.querySelector(".view_more_fabric");
        container_node.insertBefore(insert_view_more_fabrics, first_view_more_node);
      }

      // Check to ensure, if any are hidden and there is no view-more button, then show them
      if(!container_node.querySelector("#fabric_reveal_btn")) {
        if(container_node.children.length > 0) {
          Array.from(container_node.children).forEach(item => {
            if(item.style.display == "none" && item.classList.contains("fabric_parent")){
              item.style.display = "";
            }
          });
        }
      }

    }

    else {

      // Convert first item
      convert_to_elaborate_fabric(container_node.children[0], { "hide": false });

      // Convert 'partner' if exists
      if(container_node.children.length === 2) {
        convert_to_elaborate_fabric(container_node.children[1], { "hide": false });
      }

      // Convert 'partner' if exists
      if(container_node.children.length > 2 && (container_node.children[1].hasAttribute("data-fabric-partner"))) {
        convert_to_elaborate_fabric(container_node.children[1], { "hide": false });
      }
      
    }


    const swiper_items = [];
    Array.from(container_node.querySelectorAll(".elaborate_fabric")).forEach(node => {
      swiper_items.push(node);
    });
    if(swiper_items.length > 0) {
      this.utility__swiperfy_items(swiper_items, {
        "container_outer": null,
        "container_inner": null,
      });
    }



      // House elaborate fabrics in container
    if(container_node.querySelector(".elaborate_fabric")){
      const elaborate_container = document.createElement("div");
      elaborate_container.classList = "elaborate_fabrics_container";

      const children = Array.from(container_node.children);
      children.forEach(child => {
        if(child.classList.contains("elaborate_fabric") || child.getAttribute("id") == "fabric_view_more_panel") {
          elaborate_container.appendChild(child);
        }
      });
      if(elaborate_container.children.length > 0) {
        container_node.insertBefore(elaborate_container, container_node.children[0]);
      }

    }



  }



  extension__fabric_comparison_modal(query_selector_append){

    const vid_url = this.class_data.fabric_comparison.find(item => item.modal_video_url)?.modal_video_url || false;

    if(this.class_data.fabric_comparison.length == 2 && document.querySelector(query_selector_append) && vid_url) {
      const trigger_target = document.querySelector(query_selector_append);

      const trigger_element = document.createElement("button");
      trigger_element.classList.add("trigger_fabric_comparison_info");
      trigger_element.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 201 201">
          <path d="M131.5,142s-8.5,13.8-12.9,19.7c-4.4,5.9-9.2,9.2-13.6,9.2s-4.2-6.6-.2-17.5c4.1-10.9,25.8-83.6,25.8-83.6l-66.7,1.8-4.1,13.3h16.9s12.2-.6,4.6,16.9c-7.6,17.5-20.3,58.8-20.3,68.7s5.3,21.6,25.4,21.6,34.6-9.2,54.5-42.4l-9.6-7.7Z"/>
          <circle cx="115.7" cy="31" r="23.1" transform="translate(12 90.9) rotate(-45)"/>
        </svg>
      `;
      trigger_target.appendChild(trigger_element);

      function create_col(json, number){
        var html_img = json.fabric_thumbnail_image.replace("1x1", "200x200");
        if(json.fabric_thumbnail_img_override) {
          html_img = json.fabric_thumbnail_img_override;
        }
          
        var html_h4 = `<h4 class="elaborate_fabric_title">${json.fabric_title}</h4>`;
        if(!json.current && json.cheapest_product.url) {
          html_h4 = `<a href="${json.cheapest_product.url}"><h4 class="elaborate_fabric_title">${json.fabric_title}</h4></a>`;
        }

        var data = `
          <div id="fsm_eval_column_0${number}" class="fsm_eval_col">
            <img src="${html_img}" width="150" height="150">
            ${html_h4}
            <div class="inner_html_area">${json.html_field_01}</div>
          </div>
        `;
        return data;
      }

      const col1_html = create_col(this.class_data.fabric_comparison[0], 1);
      const col2_html = create_col(this.class_data.fabric_comparison[1], 2);

      const modal_html = document.createElement("div");
      modal_html.id = "fabric_selection_modal";
      modal_html.classList = "unactive";

      const modal_backdrop = document.createElement("div");

      modal_html.innerHTML = `
          <div id="fsm_backdrop"></div>
          <div id="fsm__main">
              <button id="fsm_modal_closer_x">
                  <span>X</span>
                  <svg version="1.1" id="fms_svg_wave" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 51 47" style="enable-background:new 0 0 51 47;" xml:space="preserve"> <path style="fill:#FFFFFF;" d="M51,0H8.5c6.9,0.8,12.7,6,14,13l0.5,2.4c1.3,6.5,6.3,11.6,12.8,12.8l2.4,0.5c6.7,1.3,11.7,6.6,12.9,13.1V0z"></path></svg>
              </button>
              <div id="fsm__hero_banner">
                  <video playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="metadata">
                      <source src="${vid_url}" type="video/mp4">
                  </video>
                  <span class="label empty"></span>
              </div>
              ${col1_html}
              ${col2_html}
              <div class="clearspace" style="width: 100%; height: 1px; display: block;"></div>
          </div>
      `;
      document.body.appendChild(modal_html);
      const modal_fsm_main = modal_html.querySelector("#fsm__main");

      /* Modal Functionality */
      function toggle_fabric_modal(show) {
        if(show) {
          document.body.style.overflow = "hidden";
          modal_html.classList.add("active");
          modal_html.classList.add("pre_enter");
          setTimeout(()=> { modal_html.classList.remove("pre_enter"); }, 100);
        }
        else {
          modal_html.classList.add("leaving");
          document.body.style.overflow = "";
          setTimeout(()=> { modal_html.classList = ""; }, 300);
          modal_fsm_main.classList.remove("extended");
        }
      }

      trigger_target.addEventListener("click", ()=> { toggle_fabric_modal(true);});
      modal_html.querySelector("#fsm_modal_closer_x").addEventListener("click", ()=> { toggle_fabric_modal(false);});
      modal_html.querySelector("#fsm_backdrop").addEventListener("click", ()=> { toggle_fabric_modal(false);});



      /* - Modal Drag Close Functionality */
      modal_fsm_main.addEventListener("touchstart", Drag_Close___TouchStart);
      var initial_y;
      const buffer = 50;
      const close_distance = 105;
      var stretch;
      function Drag_Close___TouchStart(e){
        stretch = 0;
        if(modal_fsm_main.scrollTop < 20){
          initial_y = e.touches[0].screenY;
          modal_fsm_main.addEventListener("touchmove", Drag_Close___TouchMove);
          modal_fsm_main.addEventListener("touchend", Drag_Close___TouchEnd);
        }
      }
      function Drag_Close___TouchMove(e){
        const current_y = e.touches[0].screenY;
        if(current_y > initial_y + buffer) {
          stretch = (current_y - (initial_y + buffer)) / 2;
          modal_fsm_main.style.transform = `translateY(${stretch}px)`;
          modal_html.classList.add("moving");
        }
        else {
          stretch = 0;
          modal_html.classList.remove("moving");
          modal_fsm_main.style.transform = `translateY(0px)`;
        }
      }
      function Drag_Close___TouchEnd(e){
        if(stretch > close_distance) {
          modal_html.classList.remove("moving");
          modal_fsm_main.style.transform = `translateY(1200px)`;
          toggle_fabric_modal(false);
          setTimeout(()=>{
            modal_fsm_main.style.transform = ``;
          }, 600);
        }
        else {
          modal_html.classList.remove("moving");
          modal_fsm_main.style.transform = `translateY(0px)`;
        }
        modal_fsm_main.removeEventListener("touchmove", Drag_Close___TouchMove);
        modal_fsm_main.removeEventListener("touchend", Drag_Close___TouchEnd);
      }
      trigger_target.addEventListener("click", ()=> { toggle_fabric_modal(true);});
      modal_html.querySelector("#fsm_modal_closer_x").addEventListener("click", ()=> { toggle_fabric_modal(false);});
      modal_html.querySelector("#fsm_backdrop").addEventListener("click", ()=> { toggle_fabric_modal(false);});

    }

  }

  


  extension__item_card_update(){

    const a_swatches = this.output_container_div.querySelectorAll("a.product-colour-swatch");

    a_swatches.forEach(a => a.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // try stopImmediatePropagation instead
      update_swatch_info(e.currentTarget );
    }));


    function update_swatch_info(target){
      
      const product_card_ = target.closest("li.product");
      const new_title = target.getAttribute("data_product_title");
      const new_subtitle = target.getAttribute("data_product_subtitle");
      const new_img = target.getAttribute("data_product_img");
      const new_img_srcset = target.getAttribute("data_product_img_srcset");

      const new_secondary_img = target.getAttribute("data_product_img_secondary");
      const new_secondary_img_srcset = target.getAttribute("data_product_img_srcset_secondary");

      const new_price = target.getAttribute("data_product_price_current");
      const new_price_original = target.getAttribute("data_product_price_original");
      const new_url = target.getAttribute("data_product_url");
      const new_vendor = target.getAttribute("data_product_vendor");


      if(new_title && new_img && new_price && new_url) {

        product_card_.querySelectorAll("a").forEach(a => a.classList.remove("active"));
        target.classList.add("active");
          
        // Update Product Vendor
        if(product_card_.querySelector(".brand")) { product_card_.querySelector(".brand").innerHTML = new_vendor; }
          
        // Update Product Title
        if(product_card_.querySelector(".title a")) { product_card_.querySelector(".title a").innerHTML = new_title; }
          
        // Update Product Subtitle
        if(new_subtitle){
          if(product_card_.querySelector(".title a")) { product_card_.querySelector(".title a").innerHTML += `<span class="sub-title">${new_subtitle}</span>`; }
        }

        // Update Product Price
        if(product_card_.querySelector(".product-item__price")) { product_card_.querySelector(".product-item__price").innerHTML = `<span class="money money-current">${new_price}</span>`; }

        // Update Product Original Price
        if(new_price_original && new_price_original != "null"){
          if(product_card_.querySelector(".product-item__price")) { product_card_.querySelector(".product-item__price").innerHTML = `<span class="original money">${new_price_original}</span>${product_card_.querySelector(".product-item__price").innerHTML}`; }
        }
        else {
          if(product_card_.querySelector(".product-item__price")) { product_card_.querySelector(".product-item__price").innerHTML = `${product_card_.querySelector(".product-item__price").innerHTML}`; }
        }

        // Update Main Product Image
        if(product_card_.querySelector(".product-card-figure picture")) {
          product_card_.querySelector(".product-card-figure picture").childNodes.forEach(node => {
            if(node.nodeName == "SOURCE"){
              node.setAttribute("original_media", node.getAttribute("media"));
              node.setAttribute("media", node.getAttribute("(max-width: 1px)"));
            }
            if(node.nodeName == "IMG"){
              node.setAttribute("src", new_img);
              node.setAttribute("srcset", new_img_srcset);
            }
          });
        }

        // Update Secondary Product Image if available
        if(product_card_.querySelectorAll(".product-card-figure picture").length > 1) {
          product_card_.querySelectorAll(".product-card-figure picture")[1].childNodes.forEach(node => {
            if(node.nodeName == "SOURCE"){
              node.setAttribute("original_media", node.getAttribute("media"));
              node.setAttribute("media", node.getAttribute("(max-width: 1px)"));
            }
            if(node.nodeName == "IMG"){
              node.setAttribute("src", new_secondary_img);
              node.setAttribute("srcset", new_secondary_img_srcset);
            }
          });
        }

        // Update Main Product URL
        if(product_card_.querySelector(".product-card-figure a")) { product_card_.querySelector(".product-card-figure a").href = new_url; }
        if(product_card_.querySelector(".product-card-footer .title a")) { product_card_.querySelector(".product-card-footer .title a").href = new_url; }


        if(product_card_.querySelectorAll(".loader").length === 0){
          product_card_.querySelector(".product-card-figure").innerHTML += `<div class="loader" style="display: none;"></div>`
          var img_loaded = false;
          jQuery(product_card_.querySelector('.loader')).css("opacity", "0");
          jQuery(product_card_.querySelector('.loader')).show();
          setTimeout(()=> {
            if(img_loaded == false){
              $(product_card_.querySelector('.loader')).css("opacity", "1");
            }
          }, 250);
          jQuery(product_card_.querySelector(".product-card-figure img")).on('load', function(){
            // hide/remove the loading image
            jQuery(product_card_.querySelector('.loader')).hide();
            jQuery(product_card_.querySelector('.loader')).css("opacity", "0");
            img_loaded = true;
          });
        }

        // If product item has secodary image track, reset the track position back to 0
        if(typeof(Product_Item_Changed___Reset_Index) !== 'undefined'){
          Product_Item_Changed___Reset_Index(event.target.closest(".product-item__"));
        }


      }


    }

  }



  extension__sort_swatches_into_tiers(input_container){

    try {

      const container = input_container.querySelector(".product-colour-swatch")?.parentElement;

      // Checks current in case ie footstool, too many swatches and there may not be a current
      if(container && container.querySelector("a.product-colour-swatch.current")) {

        const fabric_swatch_containers = [];
        const swatches = Array.from(container.querySelectorAll(".product-colour-swatch"));

        
        // Create Swatch Fabric Parent Containers
        //  --  Get swatch data fabrics and create the div elements of the fabric containers
        swatches.forEach( (swatch) => {
          var attribute = swatch.getAttribute("data-u-handle");
          if(!attribute){
            throw new Error("Item does not have 'Data-Fabric'");
          }
          if(!fabric_swatch_containers.find(item => item.getAttribute("data-fabric-u-parent") === attribute)) {
            const div = document.createElement("div");
            div.setAttribute("data-fabric-u-parent", attribute);
            div.classList = "data-fabric-parent";
            fabric_swatch_containers.push(div);
          }
        });
        //  --  Append the relevant swatches to the stored fabric containers div ref
        fabric_swatch_containers.forEach((fabric_container) => {
          const fabric_name = fabric_container.getAttribute("data-fabric-u-parent");
          const swatches_of_fabric = swatches.filter(swatch => swatch.getAttribute("data-u-handle") == fabric_name);
          for(const swatch of swatches_of_fabric) {
            fabric_container.appendChild(swatch);
          }
        });
        //  --  Display the correct fabric container and hide the rest
        fabric_swatch_containers.forEach(fabric_container => {
          container.append(fabric_container);
          if(fabric_container.querySelector("a.product-colour-swatch.current")) {
            fabric_container.style.display = "";
          }
          else {
            fabric_container.style.display = "none";
          }
        });

        swatches.forEach(swatch => {
          swatch.style.display = "";
        });




        // Split the colours into groups if relevant
        fabric_swatch_containers.forEach((fabric_container) => {
          let swatch_tier_map = [];
          const fabric_child_swatches = Array.from(fabric_container.querySelectorAll(".product-colour-swatch"));
          fabric_child_swatches.forEach(fabric_swatch => {
            // - Double check Swatch has 'data-tier' attribute, which it should always have
            if(!fabric_swatch.getAttribute("data-tier")) {
              console.error("Tier missing for: ", fabric_swatch);
            }
            // - See if the data-tier exists in the 'swatch_tier_map'
            if(!swatch_tier_map.find(item => item.index == fabric_swatch.getAttribute("data-tier"))) {
              const obj = {
                "index": parseInt(fabric_swatch.getAttribute("data-tier")),
                "swatches" : []
              }
              swatch_tier_map.push(obj);
            }
            // - Add swatch to the relevant tier in the swatch_tier_map's JSON object for the relevant tier 
            (swatch_tier_map.find(item => item.index == fabric_swatch.getAttribute("data-tier"))).swatches.push(fabric_swatch);
          });

          // Reorder so best tier is first
          if(this.class_data?.fabric_comparison?.length > 1){
            if(this.class_data.fabric_comparison[0].current == true) {
              swatch_tier_map = swatch_tier_map.sort((a, b) => b.index - a.index );
            }
          }


          // Find a ref for 'current' swatch, and if exists store it to add it first later
          let currentSwatch = null;
          for (const tier_map of swatch_tier_map) {
            for(const swatch of tier_map.swatches) {
              if(swatch.classList.contains('current')) {
                currentSwatch = swatch;
                break;
              }
            }
            if (currentSwatch) break;
          }
          if(currentSwatch) {
            fabric_container.insertBefore(currentSwatch, fabric_container.children[0]);
          }

          if(swatch_tier_map.length > 1) {
            swatch_tier_map.forEach(tier => {
              for(const swatch of tier.swatches) {
                if(!swatch.classList.contains("current")) {
                  fabric_container.appendChild(swatch);
                }
              }
            });
          }

        });

      }

    }
    catch(err){
      console.error("Failed on 'extension__sort_swatches_into_tiers'", err);
    }

  }


  extension__fabric_information(container){

    const fabric_json = (this.fabrics.find(i => i.current == true));

//    fabric_json.modal_video_url = "https://www.bigberthaoriginal.com/cdn/shop/videos/c/vp/d4b03876a3ca4bb5bf641039c8c3f1f3/d4b03876a3ca4bb5bf641039c8c3f1f3.HD-1080p-7.2Mbps-58712445.mp4?v=0&noaudio";

    if(!this.class_data.fabric_information_area) {
      this.class_data.fabric_information_area = document.createElement("div");
      this.class_data.fabric_information_area.classList = "fabric_information_area greySwatchBlock swatch_pad_LR";
      container.after(this.class_data.fabric_information_area);
    }


    let fabric_modal_video_trigger = null;
    if(fabric_json?.modal_video_url) {
      if((typeof(bbv) == "object" && typeof(bbv.add_trigger_button) == "function")){
        fabric_modal_video_trigger = document.createElement("span");
        fabric_modal_video_trigger.classList.add("trigger_fabric_video");
        fabric_modal_video_trigger.setAttribute("data-vid-source", fabric_json.modal_video_url);
        fabric_modal_video_trigger.innerHTML = `<svg version="1.1" class="fabric_video_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 15" width="20px" height="15px" style="enable-background:new 0 0 20 15;" xml:space="preserve"> <polygon points="11,7 11,6 10,6 10,5 9,5 9,4 8,4 8,11 9,11 9,10 10,10 10,9 11,9 11,8 12,8 12,7 	"/> <rect x="2" y="2" width="2" height="2"/> <rect x="2" y="5" width="2" height="2"/> <rect x="2" y="8" width="2" height="2"/> <rect x="2" y="11" width="2" height="2"/> <rect x="16" y="2" width="2" height="2"/> <rect x="16" y="5" width="2" height="2"/> <rect x="16" y="8" width="2" height="2"/> <rect x="16" y="11" width="2" height="2"/> </svg>Katso video`;
        bbv.add_trigger_button(fabric_modal_video_trigger);
      }
    }



    var elab_info = "";
    if(fabric_json?.html_field_01) {
      elab_info = fabric_json.html_field_01;

      if(elab_info.includes("[-PRICE-]") && fabric_json?.cheapest_product?.price) {
        let actual_price = format_money_js((fabric_json.cheapest_product.price), "integer");
        let compare_price = false;
        if(fabric_json?.cheapest_product?.compare_at_price){
          compare_price = format_money_js((fabric_json.cheapest_product.compare_at_price), "integer");
          compare_price = `<span class="price__was"><i>Oli</i> ${compare_price}</span>`;
        }
        const price_html = `<span class="fabric_price_area"><span class="price__now"><i>Alkaen</i> ${actual_price}</span>${compare_price ? compare_price : ""}</span>`;
        elab_info = elab_info.replace("[-PRICE-]", price_html);
      }
      elab_info = `<div class="fabric_information_inner">${elab_info}</div>`;
      
    }
    this.class_data.fabric_information_area.innerHTML = elab_info;
    
    
    if(fabric_modal_video_trigger) this.class_data.fabric_information_area.querySelector(".fabric_information_inner").appendChild(fabric_modal_video_trigger);

  }


  apply_styling(){
    if(this.output_container_div.querySelectorAll(".greySwatchBlock").length > 0) {
      const greyBlocks = this.output_container_div.querySelectorAll(".greySwatchBlock");
      greyBlocks[0].classList.add("greySwatchBlock_top");
      greyBlocks[greyBlocks.length - 1].classList.add("greySwatchBlock_bottom");
    }
    this.output_container_div.classList.add("pre_anim");
    this.output_container_div.classList.add("animating");

    const first_elab_item = document.querySelector(".fabric_parent.elaborate_fabric");

    if((window.innerHeight - first_elab_item?.getBoundingClientRect().top) < 180) {
      const watch_scroll_to_animate_fabric_labels = () => {
        console.log("Scrolling...");
        if(((window.innerHeight / 2) - first_elab_item.getBoundingClientRect().top)) {        
          console.log("Threshold Met...");
          setTimeout(()=> {
            this.output_container_div.classList.remove("pre_anim");
          }, 200);
          setTimeout(()=> {
            this.output_container_div.classList.remove("animating");
          }, 1000);
          document.removeEventListener("scroll", watch_scroll_to_animate_fabric_labels);
        }
      }
      document.addEventListener("scroll", watch_scroll_to_animate_fabric_labels);   
    }
    else {
      setTimeout(() => {
        this.output_container_div.classList.remove("pre_anim");
      }, 500);
      setTimeout(()=> {
        this.output_container_div.classList.remove("animating");
      }, 1500);
    }


  }


  // Utility Functions

  utility__universal_fabric_lookup(string, key){
    try {
      const return_value = this.fabrics.find(item => item.universal_handle == string);
      if(return_value) {
        if(key) {
          if(return_value[key]) {
            return return_value[key];
          }
          else {
            throw new Error(`Unable to find key '${key}' in the located object`);
          }
        }
        else {       
          return return_value;
        }
      }
    }
    catch(err) {
      console.error(err);
      return null;
    }
  }


  utility__return_fabrics_in_array(){
    const fabricArray = Object.entries(this.fabrics).map(([key, value]) => ({
      type: key,
      ...value
    }));
    return fabricArray;
  }


  utility__fabric_button_click(fabric_node){
    if(!fabric_node.classList.contains("selected")) {

      this.fabric_nodes_list.forEach((fabric_node_list_item) => {
        fabric_node_list_item.classList.remove('selected');
        fabric_node_list_item.setAttribute('data-current', 'false');
      });
      fabric_node.classList.add('selected');
      fabric_node.setAttribute('data-current', 'true');


      var node_fabric_u_attribute = fabric_node.getAttribute("data-fabric-u-handle");

      const fabric_object = this.fabrics.find(fabric => fabric.fabric_u_handle == node_fabric_u_attribute);

      this.fabrics.forEach(fabric => {
        fabric.current = false;
      });


      if(fabric_object) {
        fabric_object.current = true;

        if(this.Cheapest_Fabric_Link_Through) {
          const cheapest_product = fabric_object.cheapest_product;
          const cheapest_product_url = cheapest_product.url;
          fabric_node.classList.add('selected');
          if(fabric_object.cheapest_product?.url) {
            window.location.href = cheapest_product_url;
            return;
          }
        }
      }

      this.utility__show_swatches_by_specific_fabrics(node_fabric_u_attribute);

    }

  }


  utility__show_swatches_by_specific_fabrics(fabric_u_handle){
    // Shows specific swatches if they are of the correct fabric
    let target_nodes, atrribute_name;

    target_nodes = this.swatch_nodes;
    atrribute_name = "data-u-handle";

    if(this.output_container_div.querySelector(".data-fabric-parent[data-fabric-u-parent]")) {
      target_nodes = this.output_container_div.querySelectorAll(".data-fabric-parent");
      atrribute_name = "data-fabric-u-parent";
    }
    else {
      target_nodes = this.swatch_nodes;
      atrribute_name = "data-u-handle";
    }



    if(fabric_u_handle){

      target_nodes.forEach((target_item) => {
        const swatch_fabric = target_item.getAttribute(atrribute_name);
        if (swatch_fabric == fabric_u_handle) {
          target_item.style.display = "";

          if(target_item.querySelectorAll(".tier_label")?.length > 1){
            this.output_container_div.querySelector(".swatch_area_colours .option-name").style.display = "none";
          }
          else {
            this.output_container_div.querySelector(".swatch_area_colours .option-name").style.display = "";
          }

        }
        else {
          target_item.style.display = "none";
        }
      });

    }
    else {
      if(typeof(fabric_u_handle) == 'undefined'){
        console.warn(`Unable to find current fabric. Ensure this product exists in the data`);
      }
      else {
        console.warn(`Invalid fabric name provided to show specific fabrics`, fabric_u_handle);
      }
    }
  }


  utility__swiperfy_items(swiper_items_array, options) {

    // options.container_outer = div | null  -  null will autowrap
    // options.container_inner = div | null  -  null will autowrap

    swiper_items_array.forEach(item => item.classList.add("swiper-slide"));
    var target;

    if(options.container_outer && options.container_inner) {
      target = options.container_outer;
      options.container_outer.classList.add("swiper");
      options.container_inner.classList.add("swiper-wrapper");
    }
    else {
      const sw_outer = document.createElement("div");
      const sw_inner = document.createElement("div");
      sw_outer.classList.add("swiper");
      sw_inner.classList.add("swiper-wrapper");
      swiper_items_array[0].parentNode.insertBefore(sw_outer, swiper_items_array[0]);
      sw_outer.appendChild(sw_inner);
      swiper_items_array.forEach(item => sw_inner.appendChild(item));
      target = sw_outer;
    }

    const swiper_options = {
      slidesPerView: "auto",
      slidesPerGroupAuto: true,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumVelocityRatio: 1.2,
      },
      speed: 250,
    }

    function run_swiper(swiper_options) {

      var swiper_ref = new Swiper(target, swiper_options);

      if(target.querySelectorAll("[data-reinstantiate-swiper]")) {
        const reinstantiate_items = target.querySelectorAll("[data-reinstantiate-swiper]");
        reinstantiate_items.forEach(rein_btn => {
          rein_btn.addEventListener("click", ()=> {
            let delay = 0;
            if(rein_btn.hasAttribute("data-reinstantiate-swiper-delay")) {
              delay = parseInt(rein_btn.getAttribute("data-reinstantiate-swiper-delay"));
            }
            setTimeout(() => {
              const progress = swiper_ref.activeIndex;
              swiper_ref.destroy();
              swiper_ref = new Swiper(target, swiper_options);
              swiper_ref.setProgress(progress);
              swiper_ref.slideTo(progress, 20);
              swiper_ref = swiper_ref;
            }, delay)
          });
        });
      }

    }


    if(document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        if(Swiper) {
          run_swiper(swiper_options);
        }
        else {
          console.log("No Swiper Found");
        }
      });
    }
    else {
      if(Swiper) {
        run_swiper(swiper_options);
      }
      else {
        console.log("No Swiper Found");
      }
    }

    
  }



  // - Elaborate Fabric Utilities

  utility__ext_elabFabric___find_premium_partner(container_node, forced_put_items){
    // forced_put_items - [Array of good and better nodes] - Used to forcefully assign these nodes as the 'Good' and 'Better' / Downgrade/Upgrade
    let upgrade_node = null;
    let downgrade_node = null;

    var partner = false;

    if(!forced_put_items) {

      // Example circumstance... selected colour is  ~[ "Cord"  ::  "Ultra Plush Cord"]~
      const current_fabric_ = this.fabrics.find(fabric => fabric.current === true);

      this.class_data.fabric_comparison = [];
      this.class_data.fabric_comparison[0] = current_fabric_;

      if(current_fabric_){

        this.fabrics.forEach(fabric => {

          if(fabric.current === false) {


              // UPGRADE:  Has premium fabric partner universal handle upgrade
              if(current_fabric_.premium_fabric_upgrade) {
                const partner_title = (this.utility__universal_fabric_lookup(current_fabric_.premium_fabric_upgrade))?.fabric_title;
                const partner_universal_fabric_handle = (this.utility__universal_fabric_lookup(current_fabric_.premium_fabric_upgrade))?.universal_handle;
                if(current_fabric_.premium_fabric_upgrade == partner_universal_fabric_handle) {
                  var node = ((Array.from(container_node.children)).find(node => node.getAttribute("data-fabric-container") == partner_title ));
                  this.class_data.fabricParner = node;
                  partner = {
                    "json_item": fabric,
                    "node": node,
                    "upsell_type": "upgrade"
                  };
                  this.class_data.fabric_comparison[1] = fabric;
                  upgrade_node = node;
                  downgrade_node = ((Array.from(container_node.children)).find(node => node.classList.contains("selected") ));
                }
              }

              // DOWNGRADE:  This items premium fabric partner universal handle upgrade is the same as current
              else if(fabric.premium_fabric_upgrade && current_fabric_.universal_handle) {
                if(fabric.premium_fabric_upgrade == current_fabric_.universal_handle) {

                  var partner_title = (this.utility__universal_fabric_lookup(fabric.universal_handle))?.fabric_title;

                  var node = ((Array.from(container_node.children)).find(node => node.getAttribute("data-fabric-container") == partner_title ));
                  this.class_data.fabricParner = node;
                  partner = {
                    "json_item": fabric,
                    "node": node,
                    "upsell_type": "downgrade"
                  };
                  this.class_data.fabric_comparison[1] = fabric;

                  downgrade_node = node;
                  upgrade_node = ((Array.from(container_node.children)).find(node => node.classList.contains("selected") ));

                }
              }
            
          }

        });

      }
    }
    else {
      forced_put_items[0] ? downgrade_node = forced_put_items[0] : null;
      forced_put_items[1] ? upgrade_node = forced_put_items[1] : null;
    }



    if(upgrade_node) {
      upgrade_node.classList.add("upG");
      upgrade_node.classList.remove("view_more_fabric");
      container_node.insertBefore(upgrade_node, container_node.querySelector(".fabric_parent"));
    }
    if(downgrade_node) {
      downgrade_node.classList.add("dwG");
      downgrade_node.classList.remove("view_more_fabric");
      container_node.insertBefore(downgrade_node, container_node.querySelector(".fabric_parent"));
    }

    // Re-Order 'span' elements so that the partner fabric is next
    if(partner){
      for (const child of container_node.children) {
        if (child.getAttribute("data-fabric-container") == partner.json_item.fabric_title) {
          child.setAttribute("data-fabric-partner", "");
          break;
        }
      }
    }
    
  }

  utility__ext_elabFabric___find_best_fabric(container_node){
    
    // Check if the current fabric has an elaborate fabric partner
    const current = this.fabrics.find(fabric => fabric.current === true);
    if(current){

      let best_fabric_handles = false;
      if(current.best_fabric_upsell) {
        if(current.best_fabric_upsell.includes("|")) {
          best_fabric_handles = current.best_fabric_upsell.split("|");
        }
        else {
          best_fabric_handles = [];
          best_fabric_handles.push(current.best_fabric_upsell);
        }
      }

      if(best_fabric_handles){

        let best_fabric_assigned = false;

        best_fabric_handles.forEach(best_fabric => {
          if(!best_fabric_assigned) {
            for (const child of container_node.children) {
              const fabric_name = this.utility__universal_fabric_lookup(best_fabric);

              if(fabric_name?.fabric_title) {
                if (child.getAttribute("data-fabric-container") == fabric_name.fabric_title) {
                  child.setAttribute("data-best-fabric", "");
                  child.classList.add("dbF");
                  child.classList.remove("view_more_fabric");

                  if(container_node.querySelector(".view_more_fabric")) {
                    const first_view_more_node = container_node.querySelector(".view_more_fabric");
                    container_node.insertBefore(child, first_view_more_node);
                  }
                  else {
                    let index_replacement;
                    if(container_node.querySelector("[data-fabric-partner]")) {
                      index_replacement = 2;
                    }
                    else {
                      index_replacement = 1;
                    }
                    container_node.insertBefore(child, container_node.children[index_replacement]);
                  }

                  this.class_data.best_fabric = child;
                  best_fabric_assigned = true;
                  break;

                }
              }
            }
          }

        });

      }
    }
  }


  utility__ext_elabFabric___find_PUT_premium_partners(container_node, current_fabric, current_node){
    try {
      const put_arrays = current_fabric.options.put.better_best;
      const fabric_nodes = Array.from(container_node.querySelectorAll(".fabric_parent"));

      var found_valid = false;
      var put_premium_partners = [];

      for(const array_item of put_arrays) {

        for(const fabric_handle of array_item) {
          const fabric_handle_string = (this.utility__universal_fabric_lookup(fabric_handle, "fabric_title"));
          if(fabric_handle_string && fabric_nodes.find(node => node.getAttribute("data-fabric-container") === fabric_handle_string) ) {
            put_premium_partners.push(fabric_nodes.find(node => node.getAttribute("data-fabric-container") === fabric_handle_string) );
            found_valid = true;
          }
          else {
            put_premium_partners.push(null);
          }
        }

        if(!found_valid) {
          put_premium_partners = [];
        }
        else {
          break;
        }

      }

      if(put_premium_partners.length > 0) {
        this.utility__ext_elabFabric___find_premium_partner(container_node, put_premium_partners);

        const current_node = container_node.querySelector(".fabric_parent.selected")
        current_node.classList.add("dbF");
        current_node.setAttribute("data-best-fabric", "");
      }

    }

    catch(err){
      console.error(err);
    }



  }

  utility__ext_elabFabric___assign_fabric_states(container_node){

    this.class_data.elaborate_state = "";

    /* state classes:
    'f3 vm'  -  3 Fabrics Shown (Good, Better and Best) With a view more
    'f3'     -  3 Fabrics Shown (Good, Better and Best)
    'f2 vm'  -  2 Fabrics Shown (Either (Good && Better && Best)) With a view more
    'f2'     -  2 Fabrics Shown (Either (Good && Better && Best) or 1 default fabric, with 1 remaining fabric hidden)
    'f1 vm'  -  1 Fabric Shown (Only a Good || Better || Best) With a view more
    'f1'     -  1 Fabric Shown (Only a Good || Better || Best)
    'f0'     -  No default visible fabrics found, so therefore no 'view more'... all are shown by default
    */

    let view_more_qualifies = false;

    const fabric_nodes = Array.from(container_node.children);

    var state_class = "";

    const default_visible_nodes = fabric_nodes.filter(node => !(node.classList.contains("view_more_fabric")));
    const default_invisible_nodes = fabric_nodes.filter(node => node.classList.contains("view_more_fabric"));

    if(default_visible_nodes.length > 2) {
      state_class = "f3";
      if(default_invisible_nodes.length > 0) {
        view_more_qualifies = true;
      }
    }
    else if(default_visible_nodes.length == 2) {
      if(default_invisible_nodes.length == 1) {
        default_invisible_nodes[0].classList.remove("view_more_fabric");
        state_class = "f3";
      }
      else {
        state_class = "f2";
      }
    }
    else if(default_visible_nodes.length == 1) {
      state_class = "f1";
      if(default_invisible_nodes > 0) {
        view_more_qualifies = true;
      }
    }
    else {
      state_class = "f0";
      default_invisible_nodes.forEach(node => node.classList.remove("view_more_fabric"));
    }

    if(view_more_qualifies) {
      state_class = state_class + " vm";
    }

    this.class_data.elaborate_state = state_class;
    container_node.classList += ` ${state_class}`;

  }

}